module.exports = __webpack_public_path__ + "static/media/salacardio.4549fbaf.jpeg";